import {h, Fragment} from "preact"
import Icon from "./Icon"
import { useState, useEffect } from "preact/hooks"

export default function FacetAccordion ({
    className,
    id,
    name,
    active,
    onClick,
    children
}) {
    const [isNewLayout, setIsNewLayout] = useState(false)

    useEffect(() => {
        if (typeof window !== 'undefined' && window.isNewLayout) {
            setIsNewLayout(true)
        }
    }, [])

    return (
        <li class={`mobile-facets__details page-width js-filter${className ? ' ' + className : ''}`}>
            <div class={`ns-sidebar-dropdown ${active ? "ns-active" : ""}`} aria-expanded={!!active}>
                <span
                    class="ns-anchor ns-d-inline-block ns-relative ns-w-100 ns-border-box mobile-facets__summary"
                    data-nosto-element="facet"
                    onClick={onClick}
                    aria-controls={`${id}-sub-menu`}
                    aria-label={`${active ? 'Collapse' : 'Expand' } ${name}`}
                >
                    <span class={`font-secondary ${isNewLayout ? "mono-sm" : "mono-lg"}`}>
                        {name}
                    </span>
                    <div class="icon-wrapper-circle">
                        {active ? <Icon name="minus" /> : <Icon name="plus" />}
                    </div>
                </span>
                <div class="ns-sidebar-submenu ns-d-none" id={`${id}-sub-menu`}>{children}</div>
            </div>
        </li>
    )
}

